import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for N503 (客訴單品保核准)
// backend/modules/n503/models/n503.go
// ============================================================

export interface N503Candidate {
  no: string;          // FN110_01
  customer: string;    // FN110_12
  amount: number;      // FN110_17 (賠償客戶金額)
  vendor_total: number; // FN110_44/45/46/54/55/56/64/65/66 加總 (客訴廠商總額)
  department: string;  // FN110_22
  opinion: string;     // FN110_8121 既有品保意見
}

export interface N503QueryRequest {
  start_no: string;
  end_no: string;
}

export interface N503QueryResponse {
  items: N503Candidate[];
  total: number;
}

export interface N503ApproveItem {
  no: string;
  opinion: string; // 加入 FN110_8121 的新品保意見
}

export interface N503ApproveResult {
  no: string;
  success: boolean;
}

export interface N503ApproveResponse {
  results: N503ApproveResult[];
  success: number;
  failed: number;
}

export const n503Api = {
  async query(request: N503QueryRequest): Promise<N503QueryResponse> {
    const response = await apiClient.post('/api/n503/query', request);
    return response.data;
  },

  // confirmed:true mirrors the confirmation dialog the caller already went
  // through in N503Form before submitting — the backend requires it
  // (backend/modules/n503/validator: ValidateApprove).
  async approve(items: N503ApproveItem[]): Promise<N503ApproveResponse> {
    const response = await apiClient.post('/api/n503/approve', {
      confirmed: true,
      items,
    });
    return response.data;
  },
};
